import { render, staticRenderFns } from "./ShareDialog.vue?vue&type=template&id=37aa289c"
import script from "./ShareDialog.vue?vue&type=script&lang=js"
export * from "./ShareDialog.vue?vue&type=script&lang=js"
import style0 from "./ShareDialog.vue?vue&type=style&index=0&id=37aa289c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports